import React from 'react';
import { I18nProvider } from '@fiverr-private/fiverr_context';
import { SELECTORS, FILTER } from '../../../config/filters';
import { SelectedFiltersTypes } from '../../../types';
import { customToString } from '../../../utils';
import { FILTERS_LOCATION } from '../../../utils/constants';
import { filterNavigation } from '../../../service/clientNavigation';
import './index.scss';

const SelectedFilters = ({ activeFilters, selectedFilters, selectedScName }) => {
    const fromSearchFlow = !!selectedScName;

    const onClick = (filter) => {
        const { id, value } = filter;
        const selector = SELECTORS.getType(id);

        const removeHandler = {
            pair: ({ activeFilters, value }) => activeFilters.map((filterValue) => filterValue === value ? FILTER.LANGUAGES_PAIR.DEFAULT: filterValue),
            multi: ({ activeFilters, value }) => activeFilters.filter((filterValue) => filterValue !== value),
            single: () => undefined
        };

        const newValue = removeHandler[selector]({ activeFilters: activeFilters[id], value });
        filterNavigation({ [id]: newValue }, activeFilters, FILTERS_LOCATION.SELECTED);
    };

    const removeAllFilters = (urlParams) => {
        urlParams.delete('ref');
    };

    const removeScFilter = () => {
        const urlParams = new URLSearchParams(window.location.search);

        urlParams.delete('sub_category');
        removeAllFilters(urlParams);

        window.location.href = `${window.location.href.split('?')[0]}?${customToString([...urlParams.entries()])}`;
    };

    return (
        <I18nProvider>
            {({ i18n }) => (
                <div className="selected-filters">
                    {fromSearchFlow && selectedScName !== i18n.t('search_perseus.filter_builder.sub_category.all_categories') &&
                    <React.Fragment>
                        <a onClick={removeScFilter}>
                            {selectedScName}
                            <span className="remove-icon"> &times; </span>
                        </a>
                    </React.Fragment>
                    }
                    {selectedFilters.map((filter) => (
                        <a key={`${filter.id}_${filter.value}`} onClick={() => onClick(filter)}>
                            {filter.alias}
                            <span className="remove-icon"> &times; </span>
                        </a>)
                    )}
                </div>
            )}
        </I18nProvider>
    );
};

SelectedFilters.propTypes = SelectedFiltersTypes;

SelectedFilters.defaultProps = {
    selectedFilters: []
};

export default SelectedFilters;
